import '../plugins/session-timeout';
import Translations from "../plugins/translations";

const language = $("html").attr("lang"),
      supportLocaleSS = ['en', 'es', 'et', 'it'],
      sessionTimeoutDisabled = $("meta[name='_disable_session_timeout']").attr("content");

let Session = {
    rootUrl: $("meta[name='_root_url']").attr("content"),
    domain: $("meta[name='_domain']").attr("content"),
    productionMode: $("meta[name='_production']").attr("content"),
    extendedSession: $("meta[name='_extended_session']").attr("content"),
    csrfParameter: $("meta[name='_csrf_parameter']").attr("content"),
    csrfHeader: $("meta[name='_csrf_header']").attr("content"),
    csrfToken: $("meta[name='_csrf']").attr("content"),
    locale: supportLocaleSS.includes(language) ? language : 'en',
    data: {},
    
    init: () => {
        if (!sessionTimeoutDisabled) {
            Session.initSessionTimeout();
        }
    },

    initSessionTimeout: () => {
        Session.data[Session.csrfParameter] = Session.csrfToken;

        $.sessionTimeout({
            title: Translations[Session.locale].SessionTimeout.title,
            message: Translations[Session.locale].SessionTimeout.message,
            logoutButton: Translations[Session.locale].SessionTimeout.logoutButton,
            keepAliveButton: Translations[Session.locale].SessionTimeout.keepAliveButton,
            warnAfter: Session.extendedSession === 'true' ? 21300000 : 3300000, // warn after 355 or 55 minutes
            redirAfter: Session.extendedSession === 'true' ? 21600000 : 3600000, // redirect after 360 or 60 minutes
            keepAliveInterval: 300000, // 5 minutes
            ignoreUserActivity: true,
            keepAliveUrl: Session.rootUrl + 'keep-alive',
            ajaxData: Session.data,
            redirUrl: Session.rootUrl, // ignored
            onRedir: function () {
                $('.countdown-holder').remove();
                $('.modal-title').text(Translations[Session.locale].SessionTimeout.sessionExpired);
                $('.expire-text').text(Translations[Session.locale].SessionTimeout.sessionExpired);
                $('#session-timeout-dialog-keepalive').hide();
                $('#session-timeout-dialog-logout').hide();
                $('#session-timeout-dialog-ok').show();
            },
            logoutUrl: Session.rootUrl, // ignored
            onLogout: () => Utility.logout(),
            countdownMessage: '{timer}',
            countdownSmart: true
        });
    }
};

export default Session;


